var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV2MenuProductWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 50.75C9.90833 50.75 9.0625 50.3875 8.3375 49.6625C7.6125 48.9375 7.25 48.0917 7.25 47.125V10.875C7.25 9.90833 7.6125 9.0625 8.3375 8.3375C9.0625 7.6125 9.90833 7.25 10.875 7.25H47.125C48.0917 7.25 48.9375 7.6125 49.6625 8.3375C50.3875 9.0625 50.75 9.90833 50.75 10.875V47.125C50.75 48.0917 50.3875 48.9375 49.6625 49.6625C48.9375 50.3875 48.0917 50.75 47.125 50.75H10.875ZM21.9313 29.4229L29 25.9188L36.0688 29.4229C36.6729 29.7451 37.2569 29.725 37.8208 29.3625C38.3847 29 38.6667 28.4764 38.6667 27.7917V10.875H19.3333V27.7917C19.3333 28.4764 19.6153 29 20.1792 29.3625C20.7431 29.725 21.3271 29.7451 21.9313 29.4229ZM19.3333 41.0833H38.6667C39.3514 41.0833 39.9254 40.8517 40.3885 40.3885C40.8517 39.9254 41.0833 39.3514 41.0833 38.6667C41.0833 37.9819 40.8517 37.408 40.3885 36.9448C39.9254 36.4816 39.3514 36.25 38.6667 36.25H19.3333C18.6486 36.25 18.0747 36.4816 17.6115 36.9448C17.1483 37.408 16.9167 37.9819 16.9167 38.6667C16.9167 39.3514 17.1483 39.9254 17.6115 40.3885C18.0747 40.8517 18.6486 41.0833 19.3333 41.0833Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2MenuProductWhite);
export default __webpack_public_path__ + "static/media/v2-menu-product-white.271fe5c7ee130fde57ea561eae7609f5.svg";
export { ForwardRef as ReactComponent };